export default __webpack_public_path__ + "static/media/content-deco-5.dbd48650.webp";